/**
 * ProjectPath - Project-wise status path component
 * Cloned from Lead Path (Path.jsx) - shows project_status instead of lead_status
 * Used inside Project Details section, works per selected project
 */
import React from "react";
import Path from "./Path";

const ProjectPath = ({ values = [], selectedValue = "" }) => {
  return <Path values={values} selectedValue={selectedValue} />;
};

export default ProjectPath;
